// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import getGlobalProps from '../../../../helpers/constants/global-props';

import NavItemElement from '../../../_common/NavItemElement/NavItemElement';

export interface HorizontalNavItemProps extends React.HTMLAttributes<HTMLElement> {
  /** Render prop for rendering custom items, like React router's Link */
  render: any;
  /** Modifier to highlight the active item */
  active?: boolean;
}

const globalProps = getGlobalProps({});

/**
 * @purpose A generic wrapper to render custom components inside a HorizontalNav
 * @group HorizontalNav
 * @categories navigation
 * @HTMLType HTMLDivElement
 */
const HorizontalNavItem = (props: HorizontalNavItemProps) => {
  const { style, className, active, render, ...otherProps } = props;
  const { props: renderProps, type } = render();
  const { className: renderClass, style: renderStyle, ...renderOtherProps } = renderProps;

  const currentTheme = useContext(ThemeContext);
  const theme = { ...currentTheme, active };

  return <NavItemElement theme={theme} {...globalProps} {...otherProps} {...renderOtherProps} as={type} />;
};

HorizontalNavItem.defaultProps = {
  active: false,
};

HorizontalNavItem.displayName = 'HorizontalNav.Item';

export default HorizontalNavItem;
